export class LoadNotifications {
    public static readonly type = '[Notification] LoadNotifications';

    constructor(public payload?: { cursor?: string | null }) {}
}

export class ClearTableNotifications {
    public static readonly type = '[Notification] ClearTableNotifications';
}

export class LoadTableNotifications {
    public static readonly type = '[Notification] LoadTableNotifications';

    constructor(public payload?: { cursor?: string | null }) {}
}

export class LoadUserNotification {
    public static readonly type = '[Notification] LoadUserNotification';

    constructor(public payload: { id: string }) {}
}

export class MarkUserNotificationAsRead {
    public static readonly type = '[Notification] MarkUserNotificationAsRead';

    constructor(public payload: { id: string }) {}
}
